import { render } from "./kyc-fields.vue?vue&type=template&id=0926ed53&lang=html"
import script from "./kyc-fields.vue?vue&type=script&lang=js"
export * from "./kyc-fields.vue?vue&type=script&lang=js"

import "./kyc-fields.vue?vue&type=style&index=0&id=0926ed53&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__